import React, { memo, useRef, useEffect } from 'react';
import { useCopyToClipboard } from '@gogame/hooks-ts';
import {
  Typography,
  Stack,
  Paper,
  MarkdownRender,
  ContentCopyIcon,
  Actions,
  Action,
  ThumbUpOffAltIcon,
  ThumbDownOffAltIcon,
  ThumbDownAltIcon,
  ThumbUpAltIcon,
} from '@gogame/components';

import {
  useChatContext,
  TYPE_USER,
  TYPE_BOT,
  FINISHED,
  ERROR,
} from 'components/AIChatbot';
import { LIKE_MARK, DISLIKE_MARK } from 'scenes/AIChatbot/constants';
import { useDislikeMessage, useLikeMessage } from 'scenes/AIChatbot/data';

const Message = memo(({ message }) => {
  const { chatId } = useChatContext();
  const [dislike] = useDislikeMessage();
  const [like] = useLikeMessage();
  const copyToClipboard = useCopyToClipboard();

  const handleCopy = () => {
    copyToClipboard(message.text);
  };

  const handleLike = async () => {
    await like({ messageId: message.id, chatId: chatId });
  };

  const handleDislike = async () => {
    await dislike({ messageId: message.id, chatId: chatId });
  };

  switch (message.type) {
    case TYPE_USER:
      return (
        <Stack
          alignItems={'end'}
          sx={{ maxWidth: '80%', alignSelf: 'flex-end' }}
        >
          <Paper
            elevation={0}
            sx={{
              bgcolor: 'action.hover',
              py: 1,
              px: 2,
              borderRadius: 4,
              borderTopRightRadius: '4px',
            }}
          >
            <Typography>{message.text}</Typography>
          </Paper>
        </Stack>
      );
    case TYPE_BOT:
      let normalizedText = message.text || 'Thinking...';

      const isAllowActionsByStatus = message.hasOwnProperty('status')
        ? [FINISHED, ERROR].includes(message.status)
        : true;

      const isShowActions =
        message.id !== 0 &&
        !message.hasOwnProperty('typingIterator') &&
        isAllowActionsByStatus;
      return (
        <Stack>
          <Typography color={'text.primary'} component={'div'}>
            <MarkdownRender value={normalizedText} />
          </Typography>
          {isShowActions && (
            <Actions spacing={0}>
              <Action
                tooltip={'Good response'}
                icon={
                  message.mark === LIKE_MARK ? (
                    <ThumbUpAltIcon
                      sx={{ fontSize: 16, color: 'primary.main' }}
                    />
                  ) : (
                    <ThumbUpOffAltIcon sx={{ fontSize: 16 }} />
                  )
                }
                onClick={handleLike}
              />
              <Action
                tooltip={'Bad response'}
                icon={
                  message.mark === DISLIKE_MARK ? (
                    <ThumbDownAltIcon
                      sx={{ fontSize: 16, color: 'primary.main' }}
                    />
                  ) : (
                    <ThumbDownOffAltIcon sx={{ fontSize: 16 }} />
                  )
                }
                onClick={handleDislike}
              />
              <Action
                tooltip={'Copy content'}
                icon={<ContentCopyIcon sx={{ fontSize: 16 }} />}
                onClick={handleCopy}
              />
            </Actions>
          )}
        </Stack>
      );
    default:
      return null;
  }
});
export default Message;
